export const environment = {
    "Url":{
        "APIUrl" : "https://app-dev-api.sesc.com.br/api/v1",
        "AISUrl" : "https://aisauthdev.sesc.com.br",
        "MSAL" : "https://app-dev.sesc.com.br"
    },
    "localizacaoPadrao": {
        latitude: -15.793889,
        longitude: -47.882778
    }
}